/**
 * Login Page for trAInedup.ai
 * Provides user authentication interface
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { LoginForm } from '../components/auth/LoginForm';
import { SEOHead } from '../components/seo/SEOHead';

/**
 * Login page component
 * Renders the login form within the main layout
 */
export const LoginPage: React.FC = () => {
  return (
    <Layout showFooter={false}>
      <SEOHead
        title="Sign In - trAInedup.ai"
        description="Sign in to your trAInedup.ai account to access your AI courses and learning progress."
        noindex={true}
      />
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <LoginForm />
        </div>
      </div>
    </Layout>
  );
};

